import { getAllUrlParams } from '@hll/driver-js-utils';
import { getParamsFromUA } from '@/common/tools';
import { ClientUtil } from '@xl/js-utils';
import watchdog from '@xl/watch-dog-jsutil';
import ua from '@xl/user-agent';

const { version, xlApp, os } = getParamsFromUA(window.navigator.userAgent);
const { appRevision } = ua.parse();
const state = {
  // 合并所有携带的 url 参数，包含 search 参数和 hash 参数
  urlParams: null,
  version: appRevision || version, // app 版本号，默认 0
  xlApp, // 是否是小拉app
  os, // 系统类型，android 还是 ios, 只有在小拉app内在能取到
  useH5Title: false,
  pageShow: true, // 页面是否显示，默认是显示的
};

// getters
const getters = {
  urlParams(state) {
    return state.urlParams;
  },
  version(state) {
    return state.version;
  },
  useH5Title(state) {
    return state.useH5Title;
  },
};

// actions
const actions = {
  initAppStore({ commit }) {
    // 合并所有 url 参数，hash 前的参数权重最高
    const allUrlParams = getAllUrlParams(window.location.href);
    const { hide_title } = allUrlParams;

    // 缓存所有url参数
    commit('setUrlParams', allUrlParams);

    // 是否隐藏 H5 标题
    if (!version && !hide_title) {
      // app 小程序 隐藏参数 均不用 H5 导航栏
      commit('setUseH5Title', true);
    }

    ClientUtil.webcall({ action: 'getAppInfo' }, (res) => {
      const appInfo = typeof res === 'string' ? JSON.parse(res) : res;
      const deviceId = appInfo?.device_id;

      if (deviceId) {
        commit('updateUrlParams', { device_id: deviceId });
      }

      // 测试 ua 识别的准确率
      const uaRes = ua.parse();
      watchdog.sendEvent(
        'ua.parse.app',
        uaRes.isInApp,
        uaRes.is_xl_user_app,
        JSON.stringify(uaRes),
        typeof res === 'string' ? res : JSON.stringify(res),
      );
    });
  },
};

// mutations
const mutations = {
  setUrlParams(state, urlParameters) {
    state.urlParams = urlParameters;
  },
  updateUrlParams(state, payload) {
    state.urlParams = {
      ...state.urlParams,
      ...payload,
    };
  },
  setUseH5Title(state, useH5Title) {
    state.useH5Title = useH5Title;
  },
  // 设置保存于app的参数
  setAppVal(state, options) {
    for (const key in options) {
      state[key] = options[key];
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
